export default "__VITE_ASSET__DijS_X3D__"